"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _UploadMaterail = _interopRequireDefault(require("@/components/UploadMaterail/UploadMaterail.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _school = require("@/api/school/school");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      showauditbackList: [],
      showauditback: false,
      ruleForm: {
        desc: ""
      },
      rules: {
        desc: [{
          required: true,
          message: "请填写退审原因",
          trigger: "blur"
        }]
      },
      wenbendialog: false,
      memberList: [],
      dialogVisible: false,
      zhidaojiaoshi: false,
      majorDialog: false,
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "报名人",
        prop: "userName",
        isShow: true,
        width: "100"
      }, {
        name: "身份",
        prop: "type",
        isShow: true,
        width: "100",
        isFormats: true
      }, {
        name: "学校名称",
        prop: "schoolName",
        isShow: true,
        width: "100"
      }, {
        name: "参赛项目",
        prop: "matchName",
        isShow: true,
        width: "100"
      }, {
        name: "参赛大类",
        prop: "matchTypeName",
        isShow: true,
        width: "100"
      }, {
        name: "参赛选手数量",
        prop: "studentCount",
        isShow: true,
        width: "100",
        countclick: true,
        click: "countclick",
        biaoji: 1
      }, {
        name: "指导教师数量",
        prop: "teacherCount",
        isShow: true,
        width: "100",
        countclick: true,
        click: "countclick",
        biaoji: 2
      }, {
        name: "状态",
        prop: "status",
        isShow: true,
        width: "100",
        isFormats: true
      }],
      funBtns: [{
        size: "small",
        click: "search",
        icon: "el-icon-search",
        name: "查询",
        type: "primary"
      }, {
        size: "small",
        click: "printout",
        icon: "",
        name: "导出/打印",
        type: "primary"
      }
      //{
      //  size: "small",
      //  click: "allaudit",
      //  icon: "",
      // name: "批量审核",
      // type: "primary"
      // }
      ],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      userInfo: {},
      options: [{
        name: "审核",
        class: "edit",
        option: "audit",
        span: 3,
        isFuntion: true,
        optionFun: "pdshenhenaniu"
      }, {
        name: "退回",
        class: "edit",
        option: "auditback",
        span: 3,
        isFuntion: true,
        optionFun: "pdshentuihui"
      }, {
        name: "查看审核进度",
        class: "edit",
        option: "showauditbackjindu",
        span: 3
      }],
      formatters: {
        status: [{
          name: "草稿",
          value: 0
        }, {
          name: "学校待审核",
          value: 1
        }, {
          name: "市级管理员待审核",
          value: 2
        }, {
          name: "项目管理员待审核",
          value: 3
        }, {
          name: "审核成功",
          value: 4
        }, {
          name: "已退回",
          value: 5
        }],
        type: [{
          name: '教师',
          value: 0
        }, {
          name: "学生",
          value: 1
        }]
      },
      sort: {
        prop: "",
        order: ""
      },
      expertId: "",
      materialNameList: [],
      materialList: [],
      status: "",
      matchId: "",
      query: {
        matchId: "",
        pageNum: 1,
        pageSize: 10
      },
      stuquery: {
        id: ""
      },
      // 审核参数
      auditquery: {
        auditContent: "",
        ids: [],
        matchId: ""
      },
      // 退审参数
      auditbackquery: {
        auditContent: "",
        ids: [],
        matchId: ""
      },
      // 查看审核进度参数
      showauditbackquery: {
        id: ""
      }
    };
  },
  methods: {
    //退回按钮显示判断
    pdshentuihui: function pdshentuihui(row, callback) {
      if (this.userInfo.roleType == 3) {
        //学校管理员
        if (row.status == 1) {
          callback(true);
        } else {
          callback(false);
        }
      }
      if (this.userInfo.roleType == 2) {
        //教育局管理员
        if (row.status == 2) {
          callback(true);
        } else {
          callback(false);
        }
      }
      if (this.userInfo.roleType == 6) {
        //项目管理员
        if (row.status == 3) {
          callback(true);
        } else {
          callback(false);
        }
      }
      if (this.userInfo.roleType == 1) {
        //项目管理员
        callback(true);
      }
    },
    //审核按钮显示判断
    pdshenhenaniu: function pdshenhenaniu(row, callback) {
      if (this.userInfo.roleType == 3) {
        //学校管理员
        if (row.status == 1) {
          callback(true);
        } else {
          callback(false);
        }
      }
      if (this.userInfo.roleType == 2) {
        //教育局管理员
        if (row.status == 2) {
          callback(true);
        } else {
          callback(false);
        }
      }
      if (this.userInfo.roleType == 6) {
        //项目管理员
        if (row.status == 3) {
          callback(true);
        } else {
          callback(false);
        }
      }
      if (this.userInfo.roleType == 1) {
        callback(false);
      }
    },
    // 查看退审原因
    showauditbackjindu: function showauditbackjindu(e) {
      console.log(e.id);
      this.showauditbackquery.id = e.id;
      this.getPartyLogList();
    },
    getPartyLogList: function getPartyLogList() {
      var _this = this;
      (0, _school.getPartyLogList)(this.showauditbackquery).then(function (res) {
        var data = res.data;
        console.log(data);
        if (res.code == 2000) {
          _this.showauditbackList = res.data;
          _this.showauditback = true;
        }
      });
    },
    submitForm: function submitForm(formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.auditbackquery.auditContent = _this2.ruleForm.desc;
          _this2.wenbendialog = false;
          _this2.exitStatus();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    exitStatus: function exitStatus() {
      var _this3 = this;
      (0, _school.exitStatus)(this.auditbackquery).then(function (res) {
        var data = res.data;
        console.log(data);
        if (res.code == 2000) {
          _this3.$message({
            type: "success",
            message: "退审成功!"
          });
          _this3.getregistrationList();
        }
      });
    },
    // 退回
    auditback: function auditback(e) {
      this.wenbendialog = true;
      this.auditbackquery.ids = [];
      this.auditbackquery.ids.push(e.id);
    },
    allauditback: function allauditback(e) {
      if (this.auditbackquery.ids.length !== 0) {
        console.log("批量退审按钮", e);
        this.wenbendialog = true;
      } else {
        this.$message({
          type: "warning",
          message: "请勾选内容"
        });
      }
    },
    allaudit: function allaudit() {
      var _this4 = this;
      if (this.auditbackquery.ids.length === 0) {
        this.$message({
          type: "warning",
          message: "请勾选内容"
        });
        return false;
      }
      this.$confirm("审核是否通过", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this4.updateStatus();
      }).catch(function () {
        _this4.$message({
          type: "info",
          message: "已取消审核"
        });
      });
    },
    // 审核
    audit: function audit(e) {
      var _this5 = this;
      console.log("审核按钮", e);
      this.$confirm("审核是否通过", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this5.auditquery.ids = [];
        _this5.auditquery.ids.push(e.id);
        _this5.updateStatus();
      }).catch(function () {
        _this5.$message({
          type: "info",
          message: "已取消审核"
        });
      });
    },
    updateStatus: function updateStatus() {
      var _this6 = this;
      (0, _school.updateStatus)(this.auditquery).then(function (res) {
        var data = res.data;
        _this6.memberList = data;
        console.log(data);
        if (res.code == 2000) {
          _this6.$message({
            type: "success",
            message: "审核成功!"
          });
          _this6.getregistrationList();
        }
      });
    },
    countclick: function countclick(e, biaoji) {
      console.log(e, biaoji);
      this.dialogVisible = true;
      this.stuquery.id = e.id;
      if (biaoji == 1) {
        this.zhidaojiaoshi = false;
        this.getStudentListByPartyInfoId();
      } else {
        this.zhidaojiaoshi = true;
        this.getTeacherListByPartyInfoId();
      }
    },
    // 获取学校报名表教师列表
    getTeacherListByPartyInfoId: function () {
      var _getTeacherListByPartyInfoId2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this7 = this;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return (0, _school.getTeacherListByPartyInfoId)(this.stuquery).then(function (res) {
                var data = res.data;
                _this7.memberList = data;
                console.log(data);
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTeacherListByPartyInfoId() {
        return _getTeacherListByPartyInfoId2.apply(this, arguments);
      }
      return getTeacherListByPartyInfoId;
    }(),
    // 获取学校报名表学生列表
    getStudentListByPartyInfoId: function () {
      var _getStudentListByPartyInfoId2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this8 = this;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return (0, _school.getStudentListByPartyInfoId)(this.stuquery).then(function (res) {
                var data = res.data;
                _this8.memberList = data;
                console.log(data);
              });
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getStudentListByPartyInfoId() {
        return _getStudentListByPartyInfoId2.apply(this, arguments);
      }
      return getStudentListByPartyInfoId;
    }(),
    // 获取学校下报名表列表
    getregistrationList: function () {
      var _getregistrationList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this9 = this;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 1;
              return (0, _school.registrationList)(this.query).then(function (res) {
                var data = res.data;
                _this9.listData = data.list;
                _this9.totalData = data.total;
              });
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getregistrationList() {
        return _getregistrationList.apply(this, arguments);
      }
      return getregistrationList;
    }(),
    del: function del(i) {
      this.materialList[i].fileName = "";
      this.materialList[i].uploadFileShow = true;
    },
    listBureau: function listBureau() {},
    dels: function dels() {},
    // 新增
    save: function save() {},
    edit: function edit() {},
    handleSelectionChange: function handleSelectionChange(val) {
      console.log(val);
      var newarr = [];
      val.forEach(function (item) {
        return newarr.push(item.id);
      });
      this.auditquery.ids = newarr;
      this.auditbackquery.ids = newarr;
      console.log("测试数组", newarr);
    },
    deleteById: function deleteById() {},
    distribution: function distribution() {},
    viewAdmin: function viewAdmin() {},
    sortChange: function sortChange() {},
    handleCurrentChange: function handleCurrentChange(val) {
      this.query.pageNum = val;
      this.getregistrationList();
    },
    handleSizeChange: function handleSizeChange(val) {
      console.log('分页', val);
      this.query.pageSize = val;
      this.getregistrationList();
    },
    uploadMajor: function uploadMajor() {},
    handleClose: function handleClose() {
      this.wenbendialog = false;
      this.dialogVisible = false;
      this.showauditback = false;
    }
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default,
    UploadMaterail: _UploadMaterail.default
  },
  created: function created() {
    this.userInfo = this.$store.state.user.userInfo;
    if (this.$route.query.id != undefined) {
      this.query.matchId = this.$route.query.id;
      this.auditquery.matchId = this.$route.query.id;
      this.auditbackquery.matchId = this.$route.query.id;
      this.getregistrationList();
    }
  }
};